<template>
  <a-tag
    :color="getStatusColor(status)"
  >
    {{getStatusName(status)}}
  </a-tag>
</template>

<script>
  export default {
    name: 'PeriodStatusTag',
    props:{
      status:{
        type:String,
        default:'1',
      }
    },
    methods:{
      getStatusName(status){
        let result='未到期'
        if(status==='1'){
          result='未到期'
        }
        else if(status==='2'){
          result='可随访'
        }
        else if(status==='3'){
          result='已过期'
        }
        else if(status==='4'){
          result='已完成'
        }
        return result
      },
      getStatusColor(status){
        let result='orange'
        if(status==='1'){
          result='orange'
        }
        else if(status==='2'){
          result='green'
        }
        else if(status==='3'){
          result='red'
        }
        return result
      }
    }
  }
</script>

<style scoped>

</style>